import { FormattedMessage } from 'react-intl';

import { Lock } from '@tink/core/src/components/atoms/Icons/Lock';
import { Circle } from '../../atoms/Circle';
import { messages } from './messages';
import {
  StyledAccountSelectionContainer,
  StyledAccountSelectionText,
} from './AccountSelectionDisclaimer.styles';

export const AccountSelectionDisclaimer = () => (
  <StyledAccountSelectionContainer>
    <Circle size="xlarge" color="primary">
      <Lock color="primary" />
    </Circle>

    <StyledAccountSelectionText>
      <FormattedMessage {...messages.accountData} />
    </StyledAccountSelectionText>
  </StyledAccountSelectionContainer>
);
